import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQueryWithReauth";
import {
  ConversationTab,
  IConversationsResponse,
  IConversationThread,
  IUnreadCountResponse,
} from "./conversationsApiData";

export type GetConversationsParams = {
  tab?: ConversationTab;
  page?: number;
  limit?: number;
};

export const conversationsApi = createApi({
  reducerPath: "conversationsApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Conversation", "ConversationThread"],
  endpoints: (builder) => ({
    getConversations: builder.query<IConversationsResponse, GetConversationsParams | void>({
      query: (params) => ({
        url: "/conversations",
        params: {
          tab: params?.tab ?? "all",
          ...(params?.page ? { page: params.page } : {}),
          ...(params?.limit ? { limit: params.limit } : {}),
        },
      }),
      providesTags: ["Conversation"],
    }),
    getUnreadCount: builder.query<IUnreadCountResponse, string | void>({
      query: () => ({ url: "/conversations/unread-count" }),
      keepUnusedDataFor: 0,
    }),
    getConversationThread: builder.query<IConversationThread, string>({
      query: (uid) => ({ url: `/conversations/thread/${uid}` }),
      providesTags: (_result, _error, uid) => [{ type: "ConversationThread", id: uid }],
    }),
  }),
});

export const { useGetConversationsQuery, useGetUnreadCountQuery, useGetConversationThreadQuery } =
  conversationsApi;
